import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next'; import './styles.scss';

const QuestionHeader = ({ question }) => {
    return (
        <React.Fragment>
            <div className='about-you-container'>
                {i18n.t('motivator.about_you')}
            </div>
            <p className='question'>{question}</p>
        </React.Fragment>
    );
};

QuestionHeader.propTypes = {
    question: PropTypes.string
};

QuestionHeader.defaultProps = {
    question: null
};

export default QuestionHeader;
